export default "__VITE_ASSET__TnTBTvPv__"